//import axios from "axios";
import api from "@/services/EventService.js";

const state = {};
const getters = {
  riepilogoGenerale: (state, getters, rootState) => {
    let riepilogo = {
      parametri: rootState.parametri,
      consensi: rootState.introduzione.consensi,
      anagrafica: rootState.anagrafica,
      indirizzi: rootState.indirizzi,
      iscrizione: rootState.iscrizione,
      corsi: rootState.corsiscelti,
      statoStep: "'" + JSON.stringify(rootState.StatoStep) + "'",
      studiPrevi: "'" + JSON.stringify(rootState.studiprevi) + "'",
    };

    return riepilogo;
  },
  riepilogoGeneraleJSON: (state, getters, rootState) => {
    let riepilogoJSON = {
      JsonTemporaneo: {
        parametri: rootState.parametri,
        //consensi:"'"+JSON.stringify(rootState.introduzione.consensi)+"'",
        //anagrafica:"'"+JSON.stringify(rootState.anagrafica)+"'",
        //indirizzi:"'"+JSON.stringify(rootState.indirizzi)+"'",
        //ìiscrizione:"'"+JSON.stringify(rootState.iscrizione)+"'",
        //corsi:"'"+JSON.stringify(rootState.corsiscelti)+"'",
        //statoStep:"'"+JSON.stringify(rootState.StatoStep)+"'"
      },
    };
    return riepilogoJSON;
  },
};
const actions = {
  // salvo i dati
  async salvaDatiDBEvent({ getters }) {
    let riepilogo = getters.riepilogoGenerale;

    return new Promise((resolve, reject) => {
      api.post("/immatricolazione/", riepilogo).then(
        (response) => {
          resolve(response.data);
        },
        (error) => {
          reject(error);
        }
      );
    });
  },

  // recupero i dati

  recuperoDatiDBEvent({ rootState, commit, getters }) {
    //alert("inizio il recupero di:"+getters.riepilogoGenerale.parametri.prematricola)

    //rootState.introduzione.consensi.consenso1 = true
    api
      .get(
        "/immatricolazione/" + getters.riepilogoGenerale.parametri.prematricola
      )
      .then(
        (response) => {
          //
          let risposta = response.data;
          //alert(JSON.stringify(risposta))

          // reimpostazione dei dati dello store // SPOSTATA SULLA MUTATION!!!!
          /*rootState.introduzione.consensi.consenso1  = ((risposta.immatricolazione[0].PRIVACY_A.trim()=="S") ? true:false)
        rootState.introduzione.consensi.consenso2  = ((risposta.immatricolazione[0].PRIVACY_B.trim()=="S") ? true:false)
        rootState.introduzione.consensi.consenso3  = ((risposta.immatricolazione[0].PRIVACY_C.trim()=="S") ? true:false)
        rootState.introduzione.consensi.consenso4  = ((risposta.immatricolazione[0].PRIVACY_D.trim()=="S") ? true:false)
        rootState.anagrafica.cognome  = risposta.immatricolazione[0].COGNOME
        rootState.anagrafica.nome = risposta.immatricolazione[0].NOMESTUD
        rootState.anagrafica.nazioneNascita.CODICENU= risposta.immatricolazione[0].NASCNAZI
        rootState.anagrafica.dataNascita= risposta.immatricolazione[0].NASCDATA
        rootState.anagrafica.comuneNascita.CODICECOMUNE = risposta.immatricolazione[0].NASCCOMU
        rootState.anagrafica.linguaMadre.CODICENU= risposta.immatricolazione[0].LINGUAMADRE
        rootState.anagrafica.statoCivile.CODICENU= risposta.immatricolazione[0].STATOCIV
        rootState.anagrafica.sesso= risposta.immatricolazione[0].SESSO
        rootState.anagrafica.religione.CODICENU= risposta.immatricolazione[0].RELIGIONE
        rootState.anagrafica.cittadinanza1.CODICENU= risposta.immatricolazione[0].CITTADI1
        rootState.anagrafica.cittadinanza2.CODICENU= risposta.immatricolazione[0].CITTADI2
        rootState.anagrafica.ordineReligioso.CODICENU= risposta.immatricolazione[0].ORDINE
        rootState.anagrafica.codiceFiscale= risposta.immatricolazione[0].CODFISCA
        rootState.anagrafica.diocesi.CODICE= risposta.immatricolazione[0].DIOCESI
        rootState.anagrafica.collegio.CODICE= risposta.immatricolazione[0].COLLEGIO
        rootState.indirizzi.residenza.nazione.CODICENU= risposta.immatricolazione[0].RESNAZI
        rootState.indirizzi.residenza.comune.CODICECOMUNE= risposta.immatricolazione[0].RESCOMU
        rootState.indirizzi.residenza.cap= risposta.immatricolazione[0].RESCAP
        rootState.indirizzi.residenza.telefono= risposta.immatricolazione[0].RESTELE
        rootState.indirizzi.residenza.indirizzo= risposta.immatricolazione[0].RESINDS
        rootState.indirizzi.recapito.nazione.CODICENU= risposta.immatricolazione[0].RECNAZI
        rootState.indirizzi.recapito.comune.CODICECOMUNE= risposta.immatricolazione[0].RECCOMU
        rootState.indirizzi.recapito.cap= risposta.immatricolazione[0].RECCAP
        rootState.indirizzi.recapito.telefono= risposta.immatricolazione[0].RECTELE
        rootState.indirizzi.recapito.indirizzo= risposta.immatricolazione[0].RECINDS
        rootState.indirizzi.recapito.presso= risposta.immatricolazione[0].RECPRES
        rootState.indirizzi.recapito.cellulare= risposta.immatricolazione[0].CELLULARE.trim()
        rootState.iscrizione.dati.flagOspite= ((risposta.immatricolazione[0].CORSOLAUREA==999) ? true:false)
        rootState.iscrizione.dati.fac_scelta.CODICENU = risposta.immatricolazione[0].FACOLTA
        rootState.iscrizione.dati.ciclo_scelto.CODICENU = risposta.immatricolazione[0].CORSOLAUREA
        rootState.iscrizione.dati.spec_scelta.CODICENU = risposta.immatricolazione[0].INDIRIZZOLAUREA
        rootState.iscrizione.dati.anno_scelto = risposta.immatricolazione[0].ANNOCORSO
        rootState.iscrizione.dati.tipoIscrizione_scelta = risposta.immatricolazione[0].TIPOISCRIZIONE.trim()
        rootState.iscrizione.dati.categoria_scelta.CODICENU= risposta.immatricolazione[0].CATEGORIA
        rootState.StatoStep = JSON.parse(risposta.immatricolazione[0].STATOSTEP)
        rootState.documenti.folder = risposta.documenti
       
        if(risposta.corsi){rootState.corsiscelti.corsi = risposta.corsi}
        if(risposta.seminari){rootState.corsiscelti.seminari = risposta.seminari}
        if(risposta.letture){rootState.corsiscelti.letture = risposta.letture}
        */
          commit("restoreDati", { rootState, risposta });
        },
        (error) => {
          alert(error);
        }
      );
  },
};
const mutations = {
  salvaDatiDB: () => {
    //let preimmatricolazione= {};

    //preimmatricolazione.push('consensi:pippo')

    return "preimmatricolazione";
  },

  restoreDati(state, { rootState, risposta }) {
    function checkFlagOspite(corsolaurea) {
      if (corsolaurea == null) {
        return null;
      }
      if (corsolaurea == 999) {
        return true;
      }
      if (corsolaurea != 999) {
        return false;
      }
    }

    // recupero i dati dei consensi privacy e li salvo nello store

    api
      .get("/privacy/testi/" + rootState.parametri.prematricola)
      .then((risultato) => (rootState.introduzione.consensi = risultato.data))
      .catch((error) =>
        alert("Errore caricamento delle norme privacy:" + error)
      );

    // fine recupero dati consensi privacy

    //rootState.introduzione.consensi.consenso1 = ((risposta.immatricolazione[0].PRIVACY_A.trim() == "S") ? true : false)
    //rootState.introduzione.consensi.consenso2 = ((risposta.immatricolazione[0].PRIVACY_B.trim() == "S") ? true : false)
    //rootState.introduzione.consensi.consenso3 = ((risposta.immatricolazione[0].PRIVACY_C.trim() == "S") ? true : false)
    //rootState.introduzione.consensi.consenso4 = ((risposta.immatricolazione[0].PRIVACY_D.trim() == "S") ? true : false)
    rootState.anagrafica.cognome = risposta.immatricolazione[0].COGNOME;
    rootState.anagrafica.nome = risposta.immatricolazione[0].NOMESTUD;
    rootState.anagrafica.nazioneNascita.CODICENU =
      risposta.immatricolazione[0].NASCNAZI;
    rootState.anagrafica.nazioneNascita.DECODIF =
      risposta.immatricolazione[0].NASCNAZIDESC;
    rootState.anagrafica.dataNascita = risposta.immatricolazione[0].NASCDATAOK;
    rootState.anagrafica.comuneNascita.CODICECOMUNE =
      risposta.immatricolazione[0].NASCCOMU;
    rootState.anagrafica.comuneNascita.DECODIF =
      risposta.immatricolazione[0].NASCCOMUDESC;
    rootState.anagrafica.linguaMadre.CODICENU =
      risposta.immatricolazione[0].LINGUAMADRE;
    rootState.anagrafica.linguaMadre.DESCRIZIONE =
      risposta.immatricolazione[0].LINGUAMADREDESC;
    rootState.anagrafica.statoCivile.CODICENU =
      risposta.immatricolazione[0].STATOCIV;
    rootState.anagrafica.statoCivile.DECODIF =
      risposta.immatricolazione[0].STATOCIVDESC;
    rootState.anagrafica.sesso = risposta.immatricolazione[0].SESSO;
    rootState.anagrafica.religione.CODICENU =
      risposta.immatricolazione[0].RELIGIONE;
    rootState.anagrafica.religione.descrbreve =
      risposta.immatricolazione[0].RELIGIONEDESC;
    rootState.anagrafica.cittadinanza1.CODICENU =
      risposta.immatricolazione[0].CITTADI1;
    rootState.anagrafica.cittadinanza1.DECODIF =
      risposta.immatricolazione[0].CITTADI1DESC;
    rootState.anagrafica.cittadinanza2.CODICENU =
      risposta.immatricolazione[0].CITTADI2;
    rootState.anagrafica.ordineReligioso.CODICENU =
      risposta.immatricolazione[0].ORDINE;
    rootState.anagrafica.ordineReligioso.DECODIF =
      risposta.immatricolazione[0].ORDINEDESC;
    rootState.anagrafica.codiceFiscale = risposta.immatricolazione[0].CODFISCA
      ? risposta.immatricolazione[0].CODFISCA
      : "";
    rootState.anagrafica.diocesi.CODICE = risposta.immatricolazione[0].DIOCESI;
    rootState.anagrafica.diocesi.DIOCESI =
      risposta.immatricolazione[0].DIOCESIDESC;
    rootState.anagrafica.collegio.CODICE =
      risposta.immatricolazione[0].COLLEGIO;
    rootState.anagrafica.collegio.COLLEGIO =
      risposta.immatricolazione[0].COLLEGIODESC;
    rootState.indirizzi.residenza.nazione.CODICENU =
      risposta.immatricolazione[0].RESNAZI;
    rootState.indirizzi.residenza.nazione.DECODIF =
      risposta.immatricolazione[0].RESNAZIDESC;
    rootState.indirizzi.residenza.comune.CODICECOMUNE =
      risposta.immatricolazione[0].RESCOMU;
    rootState.indirizzi.residenza.comune.DECODIF =
      risposta.immatricolazione[0].RESCOMUDESC;
    rootState.indirizzi.residenza.cap = risposta.immatricolazione[0].RESCAP;
    rootState.indirizzi.residenza.telefono =
      risposta.immatricolazione[0].RESTELE;
    rootState.indirizzi.residenza.indirizzo =
      risposta.immatricolazione[0].RESINDS;
    rootState.indirizzi.recapito.nazione.CODICENU =
      risposta.immatricolazione[0].RECNAZI;
    rootState.indirizzi.recapito.comune.CODICECOMUNE =
      risposta.immatricolazione[0].RECCOMU;
    rootState.indirizzi.recapito.comune.DECODIF =
      risposta.immatricolazione[0].RECCOMUDESC;
    rootState.indirizzi.recapito.cap = risposta.immatricolazione[0].RECCAP;
    rootState.indirizzi.recapito.telefono =
      risposta.immatricolazione[0].RECTELE;
    rootState.indirizzi.recapito.indirizzo =
      risposta.immatricolazione[0].RECINDS;
    rootState.indirizzi.recapito.presso = risposta.immatricolazione[0].RECPRES;
    rootState.indirizzi.recapito.cellulare = risposta.immatricolazione[0].CELLULARE.trim();
    rootState.iscrizione.dati.flagOspite = checkFlagOspite(
      risposta.immatricolazione[0].CORSOLAUREA
    );
    rootState.iscrizione.dati.unita_accademica_scelta.CODICENU =
      risposta.immatricolazione[0].UNITA_ACCADEMICA;
    rootState.iscrizione.dati.unita_accademica_scelta.DECODIF =
      risposta.immatricolazione[0].UNITA_ACCADEMICA_DESC;
    rootState.iscrizione.dati.fac_scelta.CODICENU =
      risposta.immatricolazione[0].FACOLTA;
    rootState.iscrizione.dati.fac_scelta.DECODIF =
      risposta.immatricolazione[0].FACOLTA_DESC;
    rootState.iscrizione.dati.ciclo_scelto.CODICENU =
      risposta.immatricolazione[0].CORSOLAUREA;
    rootState.iscrizione.dati.ciclo_scelto.DECODIF =
      risposta.immatricolazione[0].CORSOLAUREA_DESC;
    rootState.iscrizione.dati.spec_scelta.CODICENU =
      risposta.immatricolazione[0].INDIRIZZOLAUREA;
    rootState.iscrizione.dati.spec_scelta.DECODIFICA =
      risposta.immatricolazione[0].INDIRIZZOLAUREA_DESC;
    rootState.iscrizione.dati.anno_scelto =
      risposta.immatricolazione[0].ANNOCORSO;
    rootState.iscrizione.dati.tipoIscrizione_scelta = risposta.immatricolazione[0].TIPOISCRIZIONE.trim();
    rootState.iscrizione.dati.categoria_scelta.CODICENU =
      risposta.immatricolazione[0].CATEGORIA;
    rootState.iscrizione.dati.categoria_scelta.DECODIF =
      risposta.immatricolazione[0].CATEGORIA_DESC;
    rootState.StatoStep = JSON.parse(risposta.immatricolazione[0].STATOSTEP);
    rootState.studiprevi = JSON.parse(risposta.immatricolazione[0].STUDIPREVI);
    if (risposta.documenti) {
      rootState.documenti.folder = risposta.documenti;
    }
    if (risposta.corsi) {
      rootState.corsiscelti.corsi = risposta.corsi;
    }
    if (risposta.seminari) {
      rootState.corsiscelti.seminari = risposta.seminari;
    }
    if (risposta.letture) {
      rootState.corsiscelti.letture = risposta.letture;
    }
  },
};

export default {
  state,
  mutations,
  getters,
  actions,
};
